import React from "react";
import { MapPin, Map } from "lucide-react";
import "./LocationShare.css";

const LocationDisplay = ({ address, showMap = true }) => {
  // Extraire les coordonnées de l'adresse si elles existent
  const extractCoordinates = (addr) => {
    if (!addr) return null;
    const match = addr.match(/\((-?\d+\.?\d*),\s*(-?\d+\.?\d*)\)/);
    if (match) {
      return {
        lat: parseFloat(match[1]),
        lng: parseFloat(match[2])
      };
    }
    return null;
  };

  const coordinates = extractCoordinates(address);
  const addressText = address ? address.replace(/\s*\(-?\d+\.?\d*,\s*-?\d+\.?\d*\)\s*/, "").trim() : "";

  if (!address) return null;

  return (
    <div className="location-display">
      {addressText && (
        <p style={{ margin: "0.5rem 0" }}>
          {addressText}
        </p>
      )}
      {coordinates && (
        <div className="location-info" style={{ marginTop: "0.5rem" }}>
          <p className="location-coords icon-inline">
            <MapPin size={13} strokeWidth={2.25} /> Coordonnées: {coordinates.lat.toFixed(6)}, {coordinates.lng.toFixed(6)}
          </p>
          {showMap && (
            <a
              href={`https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline btn-sm"
              style={{ marginTop: "0.5rem" }}
            >
              <Map size={14} strokeWidth={2.25} /> Voir sur la carte
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default LocationDisplay;

